import { useIntl } from 'react-intl'
import Group from 'components/utils/Group'
import BodyText from 'LuxKit/Typography/BodyText'
import PriceRowPriceCaption from 'LuxKit/PricePoints/PriceRowPriceCaption'
import PriceRowValueDiscount from 'LuxKit/PricePoints/Value/PriceRowValueDiscount'
import PriceRowCaption from 'LuxKit/PricePoints/PriceRowCaption'
import LuxPlusPriceStack from 'luxPlus/components/LuxPlusPriceStack'
import type { CruiseOfferPriceVariation } from 'lib/cruises/cruiseUtils'

export interface PriceRoomTypeProps {
  offer?: App.CruiseOffer
  priceFrom: App.CruisePriceDetails
  price: CruiseOfferPriceVariation
  memberPrice?: CruiseOfferPriceVariation
  header?: boolean
  hasValidDepartures?: boolean
}

function CruisePriceRoomTypeInfo({ priceFrom, price, memberPrice, hasValidDepartures, header = false }: PriceRoomTypeProps) {
  const intl = useIntl()

  const fromCaption = intl.formatMessage({
    id: 'lZ-S_ZGKEPbpKqabJg9G',
    defaultMessage: 'From',
    description: 'Price caption indicating starting price for cruise offer',
  })

  return (
    <>
      <Group direction="vertical" gap={4}>
        {hasValidDepartures && <div>
          <PriceRowPriceCaption>{fromCaption}</PriceRowPriceCaption>
          <LuxPlusPriceStack
            size="S"
            price={price.primaryPrice.total}
            memberPrice={memberPrice?.primaryPrice.total}
            saleUnit={price.primaryPrice.type}
          />
          <PriceRowCaption>
            {intl.formatMessage({
              id: 'mHfn5U73WKMnBwny-Ru8',
              defaultMessage: 'Twin share',
              description: 'Price caption indicating twin share room type in the cruises section',
            })}
          </PriceRowCaption>

          {!header && priceFrom.discountPills?.discountPercentage && <PriceRowValueDiscount
            type="estimate"
            discountPercentage={priceFrom.discountPills.discountPercentage}
          />}
        </div>}
      </Group>

      {!hasValidDepartures && <Group direction="vertical" verticalAlign="center" fullWidth>
        <BodyText variant="large" weight="bold" align="center">
          {intl.formatMessage({
            id: 'hZqiWh9QZkxCrRGrIaYZ',
            defaultMessage: 'This offer has sold out',
            description: 'Message displayed when cruise offer has no available departures',
          })}
        </BodyText>
      </Group>}
    </>
  )
}

export default CruisePriceRoomTypeInfo
